/***************************************************************************

    Copyright (C) 2020 Ravenpod, Inc.
    All rights reserved.

    This material contains CONFIDENTIAL INFORMATION
    that is the property of Ravenpod.com, Inc.
    Any unauthorized use, duplication or disclosure is prohibited.

***************************************************************************/
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import chart from './chart';
import array_helper from './helpers/array_helper';

// Internationalization
import i18n from './i18n'

// Amplify 
import Amplify, { Storage } from 'aws-amplify';
import '@aws-amplify/ui-vue';
// import aws_exports from './aws-exports';
let aws_exports = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:847279a9-4220-4ebe-ac7c-62eb4f30ef23",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_yrNAeUlxL",
    "aws_user_pools_web_client_id": "2irvdk82rgu3mkqlafs62agpch",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "ravenpod-storage92910-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};
Amplify.configure(aws_exports);

// Sticky 
import Sticky from 'vue-sticky-directive'
Vue.use(Sticky)

Vue.config.productionTip = false

Vue.mixin({

    computed: {
        hasSubscription: function() {
            return (this.$store.getters['auth/hasSubscription'].length > 0)
        },

        currentSubscriptions: function() {
            return this.$store.getters['auth/subscriptions']
        }
    },

    methods: {

        logout: function() {           
            this.$store.dispatch('auth/logout')
        },


        currentUserID: function() {
            if (this.isAuthenticated()) {
                return this.currentUser().username
            } else {
                return null
            }
        },

        currentUserName: function() {
            if (this.isAuthenticated()) {
                return this.currentUser().attributes.name
            } else {
                return null
            }
        },        

        currentUserCompanyName: function() {
            if (this.isAuthenticated()) {
                return this.currentUser().attributes['custom:company_name']
            } else {
                return null
            }
        },        

        currentUserEmail: function() {
            if (this.isAuthenticated()) {
                return this.currentUser().attributes.email
            } else {
                return null
            }
        },        

        currentUserPhoneNumber: function() {
            if (this.isAuthenticated()) {
                return this.currentUser().attributes.phone_number
            } else {
                return null
            }
        },        

        currentUser: function() {
            return this.$store.getters['auth/user']
        },

        currentUserProfilePictureURL: function() {
            if (this.isAuthenticated()) {
                return this.currentUser().attributes.profile
            } else {
                return null
            }
        },

        isAuthenticated: function() {
            return this.$store.getters['auth/isAuthenticated']
        },

    }
    
})

new Vue({
    i18n,
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
